<template>
    <div>
        <kgr-dropdown
            ref="impersonalAccountSelect"
            display="showLabel"
            :label="label"
            :value="value"
            :options="impersonalAccounts"
            :loading="loading"
            :inline="inline"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import ClubImpersonalAccount from '../../../../js/dto/ClubImpersonalAccount.js';
import ClubImpersonalAccountRepository from '../../../../js/repository/club/accounting/ClubImpersonalAccountRepository.js';
import Dropdown from './Dropdown.vue';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubImpersonalAccount,
            required: false,
            default: null,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            impersonalAccounts: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('Sachkonto');
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            this.loading = true;
            ClubImpersonalAccountRepository
                .findAll(this.clubId)
                .then((data) => {
                    this.impersonalAccounts = data;
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
